import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { normalizeRole, ROLES } from "../utils/rbacHelper"; // adjust path if needed

export default function AuthRedirect({ children }) {
  const user = useSelector((s) => s.auth.user);
  const token = useSelector((s) => s.auth.token) || localStorage.getItem("token");

if (!user && token) {
  return (
    <div style={{ minHeight: "40vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      Loading...
    </div>
  );
}

  // Agar user pehle se logged in hai
  if (user) {
    const role = normalizeRole(user.role);

    // 🛡️ Admin Side Dashboards
    if (
      [
        ROLES.SUPER_ADMIN,
        ROLES.MANAGER,
        ROLES.HR,
        ROLES.FIELD_EMPLOYEE,
        ROLES.OFFICE_EMPLOYEE,
        ROLES.SUB_ADMIN,
      ].includes(role)
    ) {
      return <Navigate to="/dashboard" replace />;
    }

    // 🏢 Dealer / Group Admin
    if (role === ROLES.DEALER) {
      return <Navigate to="/dashboard" replace />;
    }

    // 👁 Viewer
    if (role === ROLES.VIEWER) {
      return <Navigate to="/" replace />;
    }

    // 👤 Client / User
    if ([ROLES.USER, ROLES.CLIENT, ROLES.DRIVER].includes(role)) {
      return <Navigate to="/dashboard" replace />;
    }

    // Fallback (safety)
    return <Navigate to="/" replace />;
  }

  // Not logged in → allow access to auth pages
  return children;
}
